import { Component, Input, NgZone, OnInit, OnChanges, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { OrderService} from '../../services/order.service';
import { ReferenceNumber, SearchReferenceNumber } from '../../models/models';

@Component({
    selector: 'reference-number-grid',
    templateUrl: './reference-number-grid.component.html',
    standalone: false
})
export class ReferenceNumberGrid implements OnInit, OnChanges {
    @Input() quoteOrderID: number = 0;
    @Input() orderStopID: number = 0;
    @Input() orderNumber: string = "";
    @Input() readonly: boolean = false;

    @ViewChild(GridComponent, { static: false }) public uiGrid!: GridComponent;

    public isNew: boolean = false;
    public isEdit: boolean = false;
    public recordType: string = "";
    public refNum: ReferenceNumber = {} as ReferenceNumber;
    public refNumList: SearchReferenceNumber[] = [];
    public isLoading: boolean = false;
    public gridState: State = { skip: 0, take: 0, sort: [{ dir: 'asc', field: 'abbrev' }] };
    public gridData: GridDataResult = { data: [], total: 0 };

    constructor(private orderService: OrderService, private ngZone: NgZone) { }

    ngOnInit() {
        //this.getReferenceNumbers();
        //console.log("ngOnInit");
    }

    ngOnChanges() {
        this.getReferenceNumbers();
        //console.log("ngOnChanges");
    }

    private getReferenceNumbers() {
        this.isLoading = true;
        this.refNum = {} as ReferenceNumber;
        this.refNumList.length = 0;
        if (this.orderStopID > 0) {
            this.recordType = "OrderStop";
            this.orderService.getSearchReferenceNumbersByOrderStopID(this.orderStopID).subscribe(result => {
                this.isLoading = false;
                this.refNumList = result.resultCollection;
                this.setGrid();
                console.log("refNumList:orderStopID", this.orderStopID, this.refNumList.length);
            });
        }
        else if (this.quoteOrderID > 0) {
            this.recordType = "QuoteOrder";
            this.orderService.getSearchReferenceNumbersByQuoteOrderID(this.quoteOrderID).subscribe(result => {
                this.isLoading = false;
                this.refNumList = result.resultCollection;
                this.setGrid();
                console.log("refNumList:quoteOrderID", this.quoteOrderID, this.refNumList.length);
            });
        }
        else {
            this.isLoading = false;
        }
    }

    private setGrid() {
        this.gridData = process(this.refNumList, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.uiGrid == null) return;
            this.uiGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        this.gridData = process(this.refNumList, this.gridState);
    }

    public addNew() {
        var refTable: string = "";
        var refTableID: number = 0;
        if (this.orderStopID > 0) {
            refTable = "stops";
            refTableID = this.orderStopID;
        }
        else if (this.quoteOrderID > 0) {
            refTable = "quoteorder";
            refTableID = this.quoteOrderID;
        }
        this.refNum = {
            referenceNumberId: 0,
            erpReferenceNumberId: 0,
            referenceTable: refTable,
            quoteOrderID: this.quoteOrderID,
            referenceTableId: refTableID,
            createdBy: "Web App",
            value: "",
            erpReferenceTableKey: 0,
            orderNumber: this.orderNumber.toString(),
            referenceType: "",
            referenceTypeID: 0,
            createdDate: new Date()
        };
    }

    public edit(refNum: SearchReferenceNumber) {
        //console.log("edit", invoiceLine);
        this.orderService.getReferenceNumberByID(refNum.referenceNumberID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.refNum = result.resultCollection[0];
            }
        });
        //this.refNum = Object.assign({}, invoiceLine);
    }

    public delete(refNum: SearchReferenceNumber) {
        //console.log("edit", invoiceLine);
        if (confirm("Delete " + refNum.referenceType + " (" + refNum.value + ")?")) {
            this.orderService.deleteReferenceNumberByID(refNum.referenceNumberID).subscribe(result => {
                console.log("deleteReferenceNumber", result, refNum);
                this.getReferenceNumbers();
            });
        }
        //this.refNum = Object.assign({}, invoiceLine);
    }
}
